import * as zod from 'zod';
import { DDCheckList } from '../../../types/DataDD/DataDD';
import { buildBasePayload } from '../buildBasePayload';
import type { FormVariant } from '../types';
import { defaultAp01ToAp15Values } from '../../../Constants/Consts';

const simpleSchema = zod.object({
    taskHeader: zod.string().trim().min(1, { message: 'Please enter the task header.' }),
    taskDescription: zod.string().trim().min(1, { message: 'Please enter the task description.' }),
});

export const simpleVariant: FormVariant<typeof simpleSchema> = {
    schema: simpleSchema,
    fields: [
        { key: 'taskHeader', label: 'Task Header', placeholder: 'Task Header', kind: 'text' },
        { key: 'taskDescription', label: 'Task Description', placeholder: 'Task Description', kind: 'text' },
    ],
    defaultValues: { taskHeader: '', taskDescription: '' },
    getPayload: (data, firstTask, uuid): DDCheckList => ({
        ...buildBasePayload(firstTask, uuid),
        dd02: firstTask.dd02,
        dd03: firstTask.dd03,
        dd04: firstTask.dd04,
        dd05: firstTask.dd05,
        modelNumber: firstTask.modelNumber,
        modelDescription: firstTask.modelDescription,
        taskHeader: data.taskHeader,
        taskDescription: data.taskDescription,
        ...defaultAp01ToAp15Values,
        ap01: firstTask.ap01,
    } as DDCheckList),
};
